// @file actioncable consumer setup
import * as ActionCable from '@rails/actioncable'

let cable: ActionCable.Consumer | null = null
export function getCable(): ActionCable.Consumer {
  if (!cable) {
    const cableTag = document.getElementsByName('action-cable-uri')[0] as HTMLMetaElement
    cable = ActionCable.createConsumer(cableTag.content)
  }
  return cable
}
